/** Flota, etap 2 — część druga słownika PL (zgłoszenia, checklisty, szablony, serwisy, zakładki). Doklejana w `fleet-reports-pl.ts`. */
export const fleetReportsPlOps = {
  incidents: {
    title: 'Zgłoszenia',
    description:
      'Awarie, uszkodzenia, kolizje i nieprawidłowości zgłoszone przez kierowców — obsługa i decyzje o pojazdach.',
    search: 'Szukaj po tytule, rejestracji, zgłaszającym…',
    chipOpen: 'Otwarte',
    chipDecision: 'Czeka na decyzję',
    empty: 'Brak zgłoszeń do pokazania.',
    emptyFiltered: 'Żadne zgłoszenie nie pasuje do filtrów.',
    filterSeverity: 'Ważność',
    filterType: 'Rodzaj',
    allSeverities: 'Każda ważność',
    allTypes: 'Wszystkie rodzaje',
    onlyOpen: 'Tylko otwarte',
    onlyDecision: 'Czeka na decyzję',
    onlyIncomplete: 'Niekompletne',
    incomplete: 'Brak załączników: {count}',
    incompleteHint:
      'Szablon wymaga więcej załączników, niż dodano. Zgłoszenie nie jest blokowane — zdjęcia można dołączyć później.',
    blocksVehicle: 'Blokuje pojazd',
    col: {
      date: 'Zgłoszono',
      vehicle: 'Pojazd',
      title: 'Tytuł',
      type: 'Rodzaj',
      severity: 'Ważność',
      reporter: 'Zgłaszający',
      decision: 'Decyzja',
      status: 'Status',
    },
    detail: {
      summary: 'Szczegóły zgłoszenia',
      reporter: 'Zgłaszający',
      occurredAt: 'Zdarzenie',
      location: 'Miejsce',
      odometer: 'Stan licznika',
      description: 'Opis',
      fields: 'Dane z formularza',
      noFields: 'Szablon nie ma dodatkowych pól.',
      resolution: 'Rozwiązanie',
      assigned: 'Przypisano do',
      unassigned: 'Nie przypisano',
      assignedSaved: 'Zapisano przypisanie.',
      fromChecklist: 'Zgłoszenie z checklisty',
      openChecklist: 'Otwórz checklistę',
      photosTitle: 'Zdjęcia i dokumenty',
      statusTitle: 'Zmiana statusu',
      statusHint: 'Dostępne są tylko dozwolone przejścia z obecnego statusu.',
      statusResolution: 'Opis rozwiązania (opcjonalnie)',
      statusComment: 'Komentarz do zmiany (opcjonalnie)',
      statusNone: 'Zgłoszenie jest zamknięte — nie ma dalszych przejść.',
      statusChanged: 'Zmieniono status zgłoszenia.',
      commentTitle: 'Komentarz obsługi',
      commentPlaceholder: 'Dodaj komentarz — zgłaszający dostanie powiadomienie…',
      commentAdd: 'Dodaj komentarz',
      commentAdded: 'Dodano komentarz.',
      transition: '{from} → {to}',
      blocked: 'Pojazd został zablokowany (status „W serwisie”).',
      automatic: 'automatycznie',
      valueYes: 'tak',
      valueNo: 'nie',
    },
    decision: {
      bannerTitle: 'Pojazd {plate} czeka na decyzję',
      bannerBody:
        'Zgłoszona usterka jest poważna. Dopóki nie zdecydujesz, pojazd nie może rozpocząć nowej karty drogowej.',
      bannerVehicle:
        'Pojazd czeka na decyzję po zgłoszonej usterce — nowa karta drogowa nie może zostać rozpoczęta.',
      open: 'Podejmij decyzję',
      openIncident: 'Zobacz zgłoszenie',
      title: 'Decyzja o pojeździe',
      description: 'Zdecyduj, czy pojazd {plate} może jeździć mimo zgłoszonej usterki.',
      allow: 'Dopuść do jazdy',
      block: 'Zablokuj pojazd',
      allowHint: 'Pojazd zostaje aktywny i może rozpocząć kartę.',
      blockHint: 'Pojazd przechodzi w status „W serwisie” do czasu naprawy.',
      comment: 'Uzasadnienie decyzji',
      commentRequired: 'Podaj uzasadnienie (min. 3 znaki).',
      allowed: 'Pojazd dopuszczony do jazdy.',
      blocked: 'Pojazd zablokowany.',
      decidedBy: 'Zdecydował: {name}',
    },
  },
  checklists: {
    title: 'Checklisty',
    description:
      'Wykonane checklisty kierowców przed jazdą i po jeździe — odpowiedzi, zdjęcia i zgłoszone usterki.',
    chipTotal: 'Checklisty',
    chipDefects: 'Z usterką',
    empty: 'Brak wykonanych checklist.',
    emptyFiltered: 'Żadna checklista nie pasuje do filtrów.',
    filterPhase: 'Faza',
    allPhases: 'Obie fazy',
    onlyDefects: 'Tylko z usterką',
    col: {
      date: 'Wysłano',
      vehicle: 'Pojazd',
      driver: 'Kierowca',
      template: 'Checklista',
      phase: 'Faza',
      result: 'Wynik',
    },
    resultOk: 'Bez uwag',
    resultWarning: 'Uwagi',
    resultDefect: 'Usterka',
    resultCritical: 'Usterka krytyczna',
    detail: {
      summary: 'Podsumowanie',
      template: 'Szablon',
      version: 'wersja {n}',
      submittedAt: 'Wysłano',
      comment: 'Komentarz kierowcy',
      incident: 'Utworzone zgłoszenie',
      openIncident: 'Otwórz zgłoszenie',
      answers: 'Odpowiedzi',
      critical: 'Punkt krytyczny',
      noResult: 'bez odpowiedzi',
      noComment: 'Bez komentarza',
      photos: 'Zdjęcia: {count}',
      noPhotos: 'Brak zdjęć',
      photosOf: 'Zdjęcia do punktu',
    },
    requirements: {
      title: 'Wymagane formularze przed zamknięciem karty',
      ok: 'Wszystkie wymagane formularze są uzupełnione.',
      missing: 'Brakuje formularzy — kierowca nie zamknie tej karty.',
    },
  },
  templates: {
    title: 'Szablony',
    description: 'Szablony checklist i zgłoszeń, z których korzystają kierowcy w aplikacji.',
    tabChecklists: 'Checklisty',
    tabIncidents: 'Zgłoszenia',
    showInactive: 'Pokaż nieaktywne wersje',
    add: 'Nowy szablon',
    empty: 'Brak szablonów.',
    inactive: 'Nieaktywny',
    active: 'Aktywny',
    allVehicleTypes: 'wszystkie typy pojazdów',
    itemsCount: 'Pytań: {count}',
    fieldsCount: 'Pól: {count}',
    versionN: 'wersja {n}',
    versions: 'Wersje',
    versionsTitle: 'Wersje szablonu „{name}”',
    versionsHint:
      'Każda zmiana pytań tworzy nową wersję. Wykonane checklisty zostają przy wersji, w której je wypełniono.',
    versionCurrent: 'aktualna',
    view: 'Podgląd',
    deactivate: 'Wyłącz',
    activate: 'Włącz',
    toggled: 'Zmieniono aktywność szablonu.',
    checklist: {
      createTitle: 'Nowy szablon checklisty',
      editTitle: 'Edycja szablonu checklisty',
      name: 'Nazwa',
      code: 'Kod (stały między wersjami)',
      codeHint: 'Puste = wyliczany z nazwy. Po zapisie nie można go zmienić.',
      description: 'Opis',
      phase: 'Faza',
      vehicleTypes: 'Typy pojazdów',
      vehicleTypesHint: 'Bez zaznaczenia = wszystkie typy.',
      items: 'Pytania',
      addItem: 'Dodaj pytanie',
      question: 'Pytanie',
      helpText: 'Podpowiedź dla kierowcy',
      photo: 'Zdjęcie',
      commentReq: 'Komentarz',
      critical: 'Punkt krytyczny',
      criticalHint:
        'Usterka w tym punkcie to poważna usterka — uruchamia powiadomienia i procedurę z ustawień floty.',
      moveUp: 'Przesuń pytanie w górę',
      moveDown: 'Przesuń pytanie w dół',
      removeItem: 'Usuń pytanie',
      versioningNote:
        'Zmiana pytań lub wymagań utworzy nową wersję {next}; dotychczasowe wypełnienia zostaną przy wersji {current}.',
      versioningNone: 'Zmiana samej nazwy, opisu lub typów pojazdów zapisze się w tej samej wersji.',
      savedNew: 'Utworzono szablon checklisty.',
      savedVersion: 'Zapisano nową wersję szablonu.',
      savedInPlace: 'Zapisano zmiany szablonu.',
      resultsNote: 'Wynik odpowiedzi to zawsze: w porządku / uwaga / usterka.',
      inactiveReadonly: 'To nieaktywna wersja — nie można jej edytować. Edytuj aktualną wersję.',
    },
    incident: {
      createTitle: 'Nowy szablon zgłoszenia',
      editTitle: 'Edycja szablonu zgłoszenia',
      name: 'Nazwa',
      description: 'Opis',
      type: 'Rodzaj zgłoszenia',
      severity: 'Domyślna ważność',
      minAttachments: 'Minimalna liczba załączników',
      minAttachmentsHint:
        'Zgłoszenie bez wymaganych zdjęć nadal się zapisze, ale będzie oznaczone jako niekompletne (0–20).',
      fields: 'Pola formularza',
      addField: 'Dodaj pole',
      fieldLabel: 'Etykieta',
      fieldKey: 'Klucz',
      fieldKeyHint: 'Litery bez polskich znaków i cyfry, zaczyna się od małej litery.',
      fieldType: 'Typ',
      fieldRequired: 'Obowiązkowe',
      fieldOptions: 'Opcje (jedna w wierszu)',
      removeField: 'Usuń pole',
      saved: 'Zapisano szablon zgłoszenia.',
    },
    issues: {
      NAME_SHORT: 'Nazwa musi mieć co najmniej 2 znaki.',
      ITEMS_EMPTY: 'Dodaj co najmniej jedno pytanie.',
      ITEMS_TOO_MANY: 'Szablon może mieć najwyżej 60 pytań.',
      QUESTION_SHORT: 'Pytanie {n} jest za krótkie.',
      FIELD_KEY_INVALID: 'Pole {n}: nieprawidłowy klucz.',
      FIELD_KEY_DUPLICATE: 'Pole {n}: klucz się powtarza.',
      FIELD_LABEL_REQUIRED: 'Pole {n}: podaj etykietę.',
      FIELD_OPTIONS_REQUIRED: 'Pole {n}: lista wyboru wymaga opcji.',
      MIN_ATTACHMENTS_RANGE: 'Minimalna liczba załączników: 0–20.',
    },
  },
  service: {
    title: 'Serwisy i naprawy',
    description: 'Historia przeglądów, serwisów, napraw i opon floty wraz z kosztami i następnymi terminami.',
    add: 'Dodaj wpis',
    search: 'Szukaj po opisie, warsztacie, rejestracji…',
    chipTotal: 'Wpisy',
    empty: 'Brak wpisów serwisowych.',
    emptyFiltered: 'Żaden wpis nie pasuje do filtrów.',
    filterType: 'Rodzaj',
    allTypes: 'Wszystkie rodzaje',
    col: {
      date: 'Data',
      vehicle: 'Pojazd',
      type: 'Rodzaj',
      description: 'Opis',
      vendor: 'Warsztat',
      odometer: 'Licznik',
      cost: 'Koszt',
      next: 'Następny termin',
      status: 'Status',
    },
    nextDue: 'Następny serwis',
    nextDueNone: 'Brak zaplanowanego terminu',
    form: {
      createTitle: 'Nowy wpis serwisowy',
      editTitle: 'Edycja wpisu serwisowego',
      vehicle: 'Pojazd',
      selectVehicle: 'Wybierz pojazd',
      type: 'Rodzaj',
      status: 'Status',
      performedAt: 'Data wykonania (planowana dla zaplanowanych)',
      odometer: 'Stan licznika (km)',
      odometerHint: 'Dla wykonanych wpisów powstaje odczyt licznika — musi być zgodny z historią.',
      vendor: 'Warsztat / dostawca',
      description: 'Opis wykonanych prac',
      cost: 'Koszt (PLN)',
      invoice: 'Numer faktury',
      nextDueAt: 'Następny termin (data)',
      nextDueKm: 'Następny termin (km)',
      incident: 'Powiązane zgłoszenie',
      errVehicle: 'Wybierz pojazd.',
      errDate: 'Podaj datę.',
      errDescription: 'Opis musi mieć co najmniej 3 znaki.',
      errOdometer: 'Stan licznika: liczba całkowita 0–5 000 000.',
      errCost: 'Koszt: liczba od 0 do 10 000 000.',
      errNextKm: 'Następny przebieg: liczba całkowita 0–5 000 000.',
      saved: 'Zapisano wpis serwisowy.',
      deleted: 'Usunięto wpis serwisowy.',
      deleteConfirm: 'Usunąć ten wpis serwisowy? Operacja jest nieodwracalna.',
      documents: 'Dokumenty (faktury, protokoły)',
      saveFirst: 'Dokumenty można dodać po zapisaniu wpisu.',
    },
  },
  vtabs: {
    fuel: 'Tankowania',
    expenses: 'Koszty',
    incidents: 'Zgłoszenia',
    checklists: 'Checklisty',
    service: 'Serwisy',
    recent: 'Ostatnie wpisy',
    count: 'Razem: {count}',
    openCount: 'Otwarte: {count}',
    seeAll: 'Wszystkie wpisy',
    emptyFuel: 'Ten pojazd nie ma jeszcze tankowań.',
    emptyExpenses: 'Ten pojazd nie ma jeszcze kosztów.',
    emptyIncidents: 'Brak zgłoszeń dla tego pojazdu.',
    emptyChecklists: 'Brak wykonanych checklist dla tego pojazdu.',
    emptyService: 'Brak wpisów serwisowych dla tego pojazdu.',
    addService: 'Dodaj wpis serwisowy',
    nextDueAt: 'do {date}',
    nextDueKm: 'przy {km}',
  },
  vehicleExtra: {
    tankCapacity: 'Pojemność baku (l)',
    tankCapacityHint: 'Opcjonalnie — pozwala wychwycić tankowania większe niż bak.',
    tankCapacityError: 'Pojemność baku: liczba od 1 do 2000.',
    tankCapacityField: 'Pojemność baku',
  },
  settingsExtra: {
    formsTitle: 'Wymagane formularze przy zamykaniu karty',
    formsDescription:
      'Wymóg obowiązuje tylko wtedy, gdy dla typu pojazdu istnieje aktywny szablon checklisty danej fazy.',
    checklistBefore: 'Wymagaj checklisty przed jazdą',
    checklistAfter: 'Wymagaj checklisty po jeździe',
    fuelTitle: 'Tankowania',
    fuelDescription: 'Paragon pomaga weryfikować kwoty i litry.',
    fuelReceipt: 'Wymagaj zdjęcia paragonu przy zatwierdzaniu tankowania',
    defectTitle: 'Procedura po poważnej usterce',
    defectDescription:
      'Poważna usterka to zgłoszenie krytyczne, blokujące pojazd albo krytyczny punkt checklisty. Zawsze wysyłane jest powiadomienie do osób obsługujących zgłoszenia.',
    defectLabel: 'Co dzieje się z pojazdem',
    templatesHint: 'Pytania checklist i pola zgłoszeń edytujesz w zakładce „Szablony”.',
    openTemplates: 'Przejdź do szablonów',
  },
};
